'use strict';

(function () {

  var module = angular.module('client.components');

  controller.$inject = ['$location', 'ActiveMode', 'NgTableParams', 'reportLabels', 'ReportingSchoolYearsService',
                        'noTypeReportsList', '$log', 'ReportNavigation', 'User', 'UserInfoDefaultFactory', 'teksService',
                        'reportToCSV', 'ExperienceNavigator'];

  function controller($location, ActiveMode, NgTableParams, reportLabels, ReportingSchoolYearsService,
                      noTypeReportsList, $log, ReportNavigation, User, UserInfoDefaultFactory, teksService,
                      reportToCSV, ExperienceNavigator) {

    var ctrl = this;

    var staticColumns = ['studentName'];

    ctrl.inited = false;
    ctrl.isInDrilldown = false;
    ctrl.isTIAReport = true;
    ctrl.summaries = {};

    ctrl.adminReport = {};
    ctrl.filterYears = ReportingSchoolYearsService.get();
    ctrl.year = null;
    ctrl.filterType = {id:null};
    ctrl.filterConcept = {id:null};

    ctrl.getLabel = new reportLabels('labels', ctrl);

    ctrl.getStyleClass = function (columnName) {
      return teksService.getStyleClass(staticColumns, columnName);
    };

    ctrl.getTitlePopup = function getTitlePopup(columnName, data, columnTitle) {
      return teksService.getTitlePopup(staticColumns, columnName, data, columnTitle);
    };

    ctrl.classes = [{id:'none',name:'No Value'}];
    ctrl.filterClass = ctrl.classes[0];

    const queryClassValue = $location.search().class_id;
    const queryClassId = typeof queryClassValue === 'string' || typeof queryClassValue === 'number' ? Number(queryClassValue) : NaN;
    const initialClassId = Number.isInteger(queryClassId) && queryClassId > 0 ? queryClassId : null;
    let pendingClassSelection = initialClassId !== null;
    let allReportData;

    function getFilter() {
      var filter = {};
      var query = $location.search();
      filter.class_id = pendingClassSelection ? initialClassId : (ctrl.filterClass.id !== 'none' ? ctrl.filterClass.id : null);
      filter.year = query.year || ctrl.year;
      filter.teacher_id = query.teacher_id ? parseInt(query.teacher_id,10) : null;
      filter.type_id = query.type_id ? parseInt(query.type_id, 10) : null;
      filter.drilldown = query.drilldown || false;
      filter.metric_id = query.metric_id ? query.metric_id : null;
      return filter;
    }

    function initReportingYear() {
      ctrl.year = ctrl.filterYears[0].value;
    }

    var filter = getFilter();
    if (filter.teacher_id) {
      UserInfoDefaultFactory.get({}, {'id': filter.teacher_id}).$promise
      .then(function (response) {
        ctrl.classTeacherName = response.first_name + " " + response.last_name;
      });
    }
    else {
      ctrl.classTeacherName = User.getCurrentUser().first_name + " " + User.getCurrentUser().last_name;
    }

    ctrl.metrics = [
      {name:'Pre Test Scores', id:'pretest'},
      {name:'Post Test Scores', id:'posttest'},
      {name: '', id: 'none', status: 'DIVIDER'},
      {name:'Average Quiz Item Score', id:'quiz'},
      {name:'Total Responses', id:'total_responses'},
      {name:'Total Assessed Responses', id:'responses'},
      {name:'Time on Standard (min.)', id:'time_on_standard', label: 'label-summary-metric-time-on-standard', label_default:'Time on Standard (min.)'},
      ];
    ctrl.filterMetricName = ctrl.metrics[0].name;
    ctrl.filterMetric = ctrl.metrics[0].id;

    ctrl.setMetric = function setMetric(selection){
      teksService.setMetric(ctrl, selection);
    };

    ctrl.setClass = function setClass(selection) {
      if (!selection || !selection.id || selection.id === 'none') {
        return false;
      }
      ctrl.filterClass = selection;
      ctrl.classSelectionError = null;
      pendingClassSelection = false;
      // Students can belong to multiple classes; filter records and test scores before calculating metrics.
      ctrl.reportData = allReportData.records.filter(function(rec) { return rec.class_id === selection.id; });
      ctrl.tiaTestScores = (allReportData.tiaTestScores || []).filter(function(score) { return score.cid === selection.id; });
      ctrl.tiaAvgScores = (allReportData.avgScores || []).filter(function(score) { return score.cid === selection.id; });
      ctrl.summaries = teksService.getSummaryCells((allReportData.summaries || []).filter(function(rec) {
        return rec.class_id === selection.id || !rec.class_id;
      }));
      return teksService.setClass(ctrl, selection);
    };

    ctrl.getUnitsForStandard = function getUnitsForStandard(selectedCode) {
      let code = ctrl.expectationCodes.find(function(expCode) {
        return expCode.short_expectation_code == selectedCode;
      });
      if (code) {
        let masters = ctrl.summaries[code.id];
        if (masters) {
          return masters.experiences.filter(function(exp) {
            return !exp.name.includes(' TIA ');
          }).map(function(nonTia) {
            return nonTia.unit;
          }).filter(function(unit, index, inputArray) {
            return inputArray.indexOf(unit) == index;
          });
        }
      }
      return [];
    };

    ctrl.selectUnit = function selectUnit() {
      var element = document.getElementById("tia-popover");
      if (element) {
        element.parentNode.removeChild(element);
      }
    };

    ctrl.getExperiencesForStandard = function getExperiencesForStandard(selectedCode, unit) {
      let code = ctrl.expectationCodes.find(function(expCode) {
        return expCode.short_expectation_code == selectedCode;
      });
      if (code) {
        let masters = ctrl.summaries[code.id];
        if (masters) {
          return masters.experiences.filter(function(exp) {
            return !exp.name.includes(' TIA ') && exp.unit == unit;
          });
        }
      }
      return [];
    };

    ctrl.goToPastExperience = function (expId) {
      var expUrl = '/experience/' + expId + '/dashboard/responses';
      var query = {
        class_id: ctrl.filterClass.id,
      };
      ExperienceNavigator.navigateToExperience(expUrl, "", $location.path(), query);
    };

    ctrl.columns = [];
    ctrl.standardExpectations = [];
    ctrl.expectationCodes = {};

    function fetchAndUpdateReport() {
      var filter = getFilter();
      var isInDrilldown = filter.drilldown;

      ctrl.isInDrilldown = isInDrilldown;

      return ActiveMode.getReportData(filter).then(function (report) {
        ctrl.parent.title = (report.name || '').replace('TEKS', ctrl.getLabel('label-standard-name', 'TEKS'));
        ctrl.adminReport.id = report.report_id;
        ctrl.currentLevel = report.level;
        if(isInDrilldown){
          ctrl.currentLevel = teksService.LEVELS.CURRICULUM;
        }
        ctrl.labels = report.labels;
        ctrl.hasTypes = !noTypeReportsList.includes(report.report_kind);

        ctrl.metrics.forEach(function (metric) {
          if (metric.label){
            metric.name = ctrl.getLabel(metric.label, metric.label_default);
          }
        });

        allReportData = report.data;
        ctrl.reportData = report.data.records;
        if (report.data.short_expectation_codes && report.data.short_expectation_codes.length) {
          ctrl.expectationCodes = report.data.short_expectation_codes.filter(function(sec) {
            return ctrl.reportData.find(function(row) {
              return sec.short_expectation_code == row.short_expectation_code;
            });
          });
        } else {
          ctrl.expectationCodes = [];
        }
        ctrl.tiaTestScores = report.data.tiaTestScores;
        ctrl.tiaAvgScores = report.data.avgScores;
        ctrl.students = report.data.students;
        ctrl.tableParams = new NgTableParams(
          {
            // items per page
            count: 12
          },
          {
            dataset: [],
            // options for page size
            counts: [],
          }
        );

        if(filter.metric_id){
          ctrl.filterMetric = ctrl.metrics.filter(function (rec) {
            return rec.id === filter.metric_id;
          }).map(function (rec) {
            return rec.id;
          })[0] || ctrl.metrics[0].id;

          ctrl.filterMetricName = ctrl.metrics.filter(function (rec) {
            return rec.id === ctrl.filterMetric;
          })[0].name;
        }

        ctrl.allowArchived = teksService.isDistrictReport(ctrl);

        if (report.data.records.length > 0) {
          ctrl.allowArchived = false;
          let teacherIdForClassList = null;
          if (teksService.isCurriculumReport(ctrl) && isInDrilldown && filter.teacher_id > 0) {
            teacherIdForClassList = filter.teacher_id;
          }
          ctrl.classes = teksService.generateUniqueClassList(
            report.data.records,
            teacherIdForClassList
          );
          const matchedClass = ctrl.classes.find(function(rec) { return rec.id === filter.class_id; });
          if (pendingClassSelection && !matchedClass) {
            ctrl.filterClass = {id: 'none', name: 'No Value'};
            ctrl.reportData = [];
            ctrl.data = [];
            ctrl.summaries = {};
            ctrl.classSelectionError = 'The requested class is not available for this report.';
            return report;
          }
          ctrl.filterClass = matchedClass || ctrl.classes[0];
        }

        if(!report.data.short_expectation_codes){
          ctrl.data = [];
          return;
        }

        if (report.data.records.length) {
          ctrl.setClass(ctrl.filterClass);
        } else {
          ctrl.data = [];
          ctrl.summaries = {};
        }
        return report;
      });
    }

    ReportingSchoolYearsService.ready().then(function () {
      initReportingYear();
      return fetchAndUpdateReport();
    })
    .then(function () {
      ctrl.inited = true;
    })
    .catch(function(error) {
      $log.error("error in updating report:",error);
      ctrl.inited = true;
    });

    ctrl.downloadCSV = reportToCSV(
      function() { return teksService.exportColumns(ctrl); },
      function() { return teksService.exportData(ctrl); },
      function() { return teksService.exportFile(ctrl); },
      ','
    );
  }

  module.component('curriculumTeksTiaSummary', {
    require: {parent: '^^xpReport'},
    template: require('./curriculumTIASummary.jade'),
    controller: controller,
  });

})();
